import styled from "styled-components";
import { display } from "styled-system";

export const StyledSliderContent = styled.div`
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .slick-track {
    height: fit-content !important;
  }

  & > div:last-child {
    max-width: 500px;
  }

  & > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    align-items: flex-start;
    padding-top: 50px;
    margin: 0 auto;
    justify-content: center;
    max-width: 1280px;

    & > div,
    & > div:last-child {
      width: 50%;
      max-width: inherit;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding-left: 65px;
    padding-right: 65px;
  }
`;

export const StyledSliderWrapper = styled.div`
  background: url("./images/find-opponents-line.png");
  background-repeat: no-repeat;
  background-position: 0 50%;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    background-size: 100%;
  }
`;

export const StyledDescriptionWrapper = styled.div`
  ${display};
  padding: 16px 16px 16px 14px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  min-height: 170px;
  box-sizing: border-box;
  color: #233247;

  & h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    margin-bottom: 10px;
  }

  & p {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    max-width: 480px;
    transition: 0.5s;
    cursor: pointer;
    margin: 0 0 16px;
    min-height: 145px;
    color: ${({ active }) =>
      active ? "#233247" : "rgba(35, 50, 71, 0.494673)"};
    mix-blend-mode: normal;
    background: #ffffff;
    box-shadow: 2px 2px 5px 4px
      ${({ active }) =>
        active ? "rgba(0, 0, 0, 0.10)" : "rgba(0, 0, 0, 0.04)"};

    & h3 {
      font-size: 18px;
    }
  }
`;

export const StyledDesktopSliderControllers = styled.div`
  display: none;
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    display: flex;
    position: relative;
    z-index: 1;
    flex-direction: column;
    padding-left: 8%;
    margin-top: 10px;
    margin-bottom: -30px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    max-width: 484px;
    padding-left: 0;
  }
`;
